module.exports = __webpack_public_path__ + "img/52002768_L.9fecc730.png";